import { HttpError, request } from '@helpers/general'
import { getRegionZone } from '@helpers/geo-location'
import { useQuery, useQueryClient } from 'react-query'
import { fetchPromotions } from '@services/checkout'

const useGetPromotions = (requestItems, region, zone) => {
  const queryClient = useQueryClient()

  return useQuery({
    queryKey: ['get-promotions', requestItems, region, zone],
    queryFn: () => getPromotions(requestItems, region, zone),
    refetchOnWindowFocus: false,
  })
}

const getPromotions = async (requestItems, region, zone) => {
  let data
  await fetchPromotions({
    requestItems,
    region,
    zone,
  })
    .then(json => {
      data = json
      return data
    })
    .catch(err => {
      console.error(err)
    })
  return data
}

export default useGetPromotions
